/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { items } from "components/PerlickComponents/Dashboard/PerlickDashboard.Constant";
import { useLocation } from "react-router-dom";
import { getActiveMenuValue } from "utils";

export default function SidebarMenu() {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(" ");
  useEffect(() => {
    if (location) {
      if (activeLink !== location.pathname) {
        setActiveLink(getActiveMenuValue(location.pathname.replace(/\//, "")));
      }
    }
  }, [location, activeLink]);
  return (
    <Menu
      theme="light"
      mode="inline"
      defaultSelectedKeys={["dashboard"]}
      items={items}
      selectedKeys={[activeLink]}
      className="dashboard-sidebar-menu"
    />
  );
}
